export default __webpack_public_path__ + "static/media/full-screen.b12c988d.svg";